/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
(function($) {
    var map = null;
    var markers = [];
    var $grid = null;
    var controller = new ScrollMagic.Controller();
    var ease = Expo.easeInOut;
    $.fn.replace_html = function(html) {
        return this.each(function() {
            var el = $(this);
            el.stop(true, true, false);
            el.css({
                height: "auto",
                opacity: 0
            });
            var cur = {
                height: el.outerHeight() + "px"
            };
            el.html(html);
            var finish = {
                height: el.outerHeight() + "px",
                opacity: 1
            };
            el.css(cur).animate(finish, 750);
        });
    };



    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        'base_url': document.head.querySelector("[name=base_url]").content,
        'common': {
            init: function() {
                $(document).foundation(); // Foundation JavaScript

                Sage.common.mobile_nav();
                Sage.common.touch_menu();
                Sage.common.wow();
                Sage.common.arrow();
                Sage.common.search();
                Sage.common.twitter();
                Sage.common.accessibility();
            },
            'accessibility': function(){
                $('a').each(function() {               
                    $(this).attr('tabindex', '0');
                });
            },
            'twitter': function(){
                $('.ctf-tweet-text').each(function(){
                    var html = $(this).html();
                    html = html.replace(/[^\x00-\x7F]/g,"");
                    $(this).html(html);
                });
            },
            'search': function(){
                // open
                $('.main-menu__search').on('click', function(){
                    $('.search-modal').addClass('search-modal--open');
                    setTimeout(function(){
                        $('.search-modal__form-input').focus();
                    }, 100);
                    return false;
                });
                // close
                $('.search-modal__close').on('click', function(){ // click close
                    $('.search-modal').removeClass('search-modal--open');
                    return false;
                });
                $('.search-modal__close').keypress(function (e) { // hit enter on focus
                    var key = e.which;
                    if(key === 13) {
                        $('.search-modal').removeClass('search-modal--open');
                        return false;  
                    }
                });   
                $(document).on('keydown', function(event) { // hit esc
                    if ($('.search-modal').hasClass('search-modal--open') && event.key === "Escape") {
                        $('.search-modal').removeClass('search-modal--open');
                    }
                });

                // function
                $('.search-modal__form-input').on('focus', function(){
                    $('.search-modal__form-label').addClass('is-active');
                }).on('blur', function(){
                    if(!$('.search-modal__form-input').val()){
                        $('.search-modal__form-label').removeClass('is-active');
                    }
                });
            },
            'arrow': function() {
                // hide / show arrow while scrolling
                new ScrollMagic.Scene({
                    triggerElement: ".header",
                    triggerHook: 0,
                    offset: 150,
                })
                .on('enter', function () {
                    $('.arrow--down').removeClass('arrow--show').addClass('arrow--hide');
                    $('.side-text--top').removeClass('side-text--show').addClass('side-text--hide');
                    $('.header__top, .main-menu__search').removeClass('scrolled').addClass('scrolled');
                })
                .on('leave', function () {
                    $('.arrow--down').addClass('arrow--show').removeClass('arrow--hide');
                    $('.arrow--up').removeClass('arrow--show').addClass('arrow--hide');
                    $('.side-text--top').addClass('side-text--show').removeClass('side-text--hide');
                    $('.header__top, .main-menu__search').addClass('scrolled').removeClass('scrolled');
                })
                .addTo(controller);


                // show on footer
                new ScrollMagic.Scene({
                    triggerElement: ".footer",
                    triggerHook: 1,
                })
                .on('enter', function () {
                    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    $('.side-text--top').addClass('side-text--hide');
                    if(scrollTop > 100){
                        setTimeout(function(){
                            $('.arrow--up').addClass('arrow--show').removeClass('arrow--hide');
                        }, 1000);
                    }
                })
                .on('leave', function () {
                    $('.side-text--top').removeClass('side-text--hide');
                    $('.arrow--up').removeClass('arrow--show').addClass('arrow--hide');
                })
                .addTo(controller);


                $(window).on('resize', function(){
                    $('.arrow--up').removeClass('arrow--doesnt-fit');
                    if($('.footer').height() > $(window).height() * 0.5){
                        $('.arrow--up').addClass('arrow--doesnt-fit');
                    }
                });
                $(window).trigger('resize');


                // click arrow
                $('.arrow').on('click', function() {
                    $('.arrow').addClass('arrow--hide');
                    if ($(this).hasClass('arrow--down')) {
                        Sage.common.scrollTo($('.wrap.container'));
                    } else {
                        Sage.common.scrollToAnchor('top');
                    }
                    return false;
                });
            },
            'scrollToAnchor': function scrollToAnchor(aid) {
                var a = $("a[name='" + aid + "']");
                Sage.common.scrollTo(a);
            },
            'scrollTo': function scrollToAnchor(selector) {
                $('html,body').animate({
                    scrollTop: selector.offset().top
                }, 700);
            },
            zoom: 15,
            new_map: function($el) {
                var $markers = $('.marker');
                var args = {
                    zoom: Sage.common.zoom,
                    center: new google.maps.LatLng(0, 0),
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    styles: [{
                        "featureType": "administrative",
                        "elementType": "all",
                        "stylers": [{
                            "lightness": "0"
                        }, {
                            "gamma": "1.00"
                        }, {
                            "visibility": "simplified"
                        }]
                    }, {
                        "featureType": "administrative",
                        "elementType": "labels.text.fill",
                        "stylers": [{
                            "color": "#959595"
                        }]
                    }, {
                        "featureType": "landscape",
                        "elementType": "all",
                        "stylers": [{
                            "color": "#f2f2f2"
                        }]
                    }, {
                        "featureType": "poi",
                        "elementType": "all",
                        "stylers": [{
                            "visibility": "off"
                        }]
                    }, {
                        "featureType": "road",
                        "elementType": "all",
                        "stylers": [{
                            "saturation": -100
                        }, {
                            "lightness": 45
                        }, {
                            "visibility": "simplified"
                        }]
                    }, {
                        "featureType": "road.highway",
                        "elementType": "all",
                        "stylers": [{
                            "visibility": "simplified"
                        }]
                    }, {
                        "featureType": "road.highway",
                        "elementType": "geometry.fill",
                        "stylers": [{
                            "color": "#ffffff"
                        }]
                    }, {
                        "featureType": "road.arterial",
                        "elementType": "labels.icon",
                        "stylers": [{
                            "visibility": "off"
                        }]
                    }, {
                        "featureType": "transit",
                        "elementType": "all",
                        "stylers": [{
                            "visibility": "off"
                        }]
                    }, {
                        "featureType": "water",
                        "elementType": "all",
                        "stylers": [{
                            "color": "#dde6e8"
                        }, {
                            "visibility": "on"
                        }]
                    }],
                };
                map = new google.maps.Map($el[0], args);
                map.markers = [];
                Sage.common.add_marker($markers.first(), map);
                Sage.common.center_map(map);
                return map;
            },
            clear_marker: function(map) {
                for (var i = 0; i < map.markers.length; i++) {
                    map.markers[i].setMap(null);
                }
                map.markers = [];
            },
            add_marker: function($marker, map) {
                var icon = {
                    path: "M36.7 18.4C36.7 8.2 28.5 0 18.4 0A18.42 18.42 0 0 0 3.5 29.2l14.8 25.7 16.5-28.3h-.1c1.3-2.5 2-5.3 2-8.2zM18.4 23c-2.9 0-5.2-2.3-5.2-5.2s2.3-5.2 5.2-5.2 5.2 2.3 5.2 5.2-2.4 5.2-5.2 5.2z",
                    fillColor: '#feda30',
                    fillOpacity: 1,
                    anchor: new google.maps.Point(18, 54),
                    strokeWeight: 0,
                    scale: 1
                };
                var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
                var marker = new google.maps.Marker({
                    position: latlng,
                    icon: icon,
                    map: map
                });
                map.markers.push(marker);
                if ($marker.html()) {
                    var infowindow = new google.maps.InfoWindow({
                        content: $marker.html()
                    });
                    google.maps.event.addListener(marker, 'click', function() {
                        infowindow.open(map, marker);
                    });
                }
            },
            center_map: function(map) {
                var bounds = new google.maps.LatLngBounds();
                $.each(map.markers, function(i, marker) {
                    var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
                    bounds.extend(latlng);
                });
                if (map.markers.length === 1) {
                    map.setCenter(bounds.getCenter());
                    map.setZoom(Sage.common.zoom);
                } else {
                    map.fitBounds(bounds);
                }
            },
            mobile_nav: function() {
                $('button.hamburger').click(function() {
                    $('button.hamburger').toggleClass('active');
                    $('body').toggleClass('menu_open');
                    return false;
                });
                $('.mobile-nav .menu-item-has-children span').click(function() {
                    $(this).parents('.menu-item-has-children').toggleClass('is-open');
                });
            },
            touch_menu: function () {
                $('.header .menu-primary-navigation-container .nav > .menu-item-has-children > a', '[data-whatintent="touch"], [data-whatintent="keyboard"]').on('click', function () {
                    $(this).parent().toggleClass('is-active').siblings().removeClass('is-active');
                    return false;
                });
            },
            wow: function() {
                // set the controller for animations
                var duration = 1;

                // single wow - fadeIn & fadeInUp 
                $('.wow').each(function(i) {
                    var tl = new TimelineMax();
                    var delay = $(this).data('delay') || 0;
                    var t1_duration = $(this).data('duration') || duration;

                    var animation = {
                        ease: ease
                    };

                    if ($(this).hasClass('fadeIn')) {
                        animation.ease = ease;
                        animation.autoAlpha = 0;
                        tl.from($(this), t1_duration, animation, delay);
                    }

                    if ($(this).hasClass('fadeInUp')) {
                        animation.ease = ease;
                        animation.autoAlpha = 0;
                        animation.y = 30;
                        tl.from($(this), t1_duration, animation, delay);
                    }

                    if ($(this).hasClass('slideInRight')) {
                        animation.autoAlpha = 0;
                        animation.x = '-100%';
                        tl.from($(this), t1_duration, animation, delay);
                    }


                    new ScrollMagic.Scene({
                            triggerElement: this,
                            triggerHook: 0.9,
                            reverse: false
                        })
                        .setTween(tl) // trigger a TweenMax.to tween
                        .addTo(controller);
                });

                // series wow - fadeIn & fadeInUp 
                $('.wows').each(function(i) {
                    var tl = new TimelineMax();
                    var delay = $(this).data('delay') || 0;
                    var t1_duration = $(this).data('duration') || duration;

                    var animation = {
                        ease: ease
                    };

                    if ($('.fadeIn', this)) {
                        animation.ease = ease;
                        animation.autoAlpha = 0;
                        tl.staggerFrom($('.fadeIn', this), t1_duration, animation, 0.05, delay);
                    }

                    if ($('.fadeInUp, > .menu-item', this)) {
                        animation.ease = ease;
                        animation.autoAlpha = 0;
                        tl.staggerFrom($('.fadeInUp, > .menu-item', this), t1_duration, animation, 0.05, delay);
                    }

                    new ScrollMagic.Scene({
                            triggerElement: this,
                            triggerHook: 0.9,
                            reverse: false
                        })
                        .setTween(tl) // trigger a TweenMax.to tween
                        .addTo(controller);
                });
            }
        },
        'home': {
            init: function(){
                $('.page-header__intro-title span').addClass('animated');
                setTimeout(function(){
                    $('.page-header__intro-title span').addClass('loaded');
                },1500);
            }
        },
        'blog':{
            init: function(){
                $(document).on("sf:ajaxfinish", ".searchandfilter", function(){
                    new Foundation.Equalizer($("[data-equalizer]")).applyHeight();
                });
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function() {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.